// import { id, Interface } from 'ethers';
const {id, Interface} = require('ethers');
const isProd = true
const isMainnet = true
const ERC20 = {
	selectors: {
		decimals: "0x313ce567",
		balanceOf: "0x70a08231",
		transfer: "0xa9059cbb",
		allowance: "dd62ed3e",
		approve: "0x095ea7b3",
	},
	pad32: (hexNo0x) => hexNo0x.padStart(64, "0"),
	addrTo32: (addr) => {
		const a = addr.toLowerCase().replace(/^0x/, "");
		if (a.length !== 40) throw new Error("Invalid address: " + addr);
		return ERC20.pad32(a);
	},
	uintTo32: (bnHexNo0x) => {
		return ERC20.pad32(bnHexNo0x.replace(/^0+/, "") || "0");
	},
	hex: (...parts) => "0x" + parts.map(p => p.replace(/^0x/, "")).join(""),
	parseUint256: (hex) => {
		const h = hex.replace(/^0x/, "") || "0";
		return BigInt("0x" + h);
	},
	parseUint8(hex) {
		if (!hex || hex === "0x") return 0;
		return Number(BigInt(hex) & 0xffn);
	},
};
const ERC20_ABI = [
	"function decimals() view returns (uint8)",
	"function balanceOf(address) view returns (uint256)",
	"function allowance(address owner, address spender) view returns (uint256)",
	"function approve(address spender, uint256 amount) returns (bool)",
	"function transfer(address to, uint256 value) returns (bool)",
]

const ERC20_INTERFACE = new Interface(ERC20_ABI)

const NFT_ABI = [
	"function getOwnerTokens(address owner) external view returns (uint256[] memory)",
	"function getNFTInfo(uint256 tokenId) external view returns (tuple(uint8 tier, uint256 mintTime, string cityName, uint256 energy, uint256 energyUsed, uint256 computingPower, uint256 fuel, uint256 startResonanceTime, uint256 resonanceDepositWithdrawTime, uint256 round, bool isInResonance, uint256 fuelUsed, uint256 version))",
	"function tierUsdtPrices(uint8) external view returns (uint256)",
	"function resonanceRefundDepositTriggerAmount(uint8) external view returns (uint256)",
	"function nftResonanceRewardExpireTime() view returns (uint256)",
	"function resonancePeriod() view returns (uint256)",
	"function nftExpireTime() view returns (uint256)",
	"function resonanceRewardRate() view returns (uint256)",
]

const NFT_INTERFACE = new Interface(NFT_ABI)

const INTERACTOR_ABI = [
	"function startResonance(uint256 _tokenId, uint256 nonce, uint256 timestamp, uint256 deadline, bytes signature) external",
	"function buyNftsWithUSDT(uint8 tier, uint256 count, address _referrer, uint256 nonce, uint256 timestamp, uint256 deadline, bytes signature) external returns (uint256[])",
	"function endNftResonance(uint256 _tokenId, uint256 nonce, uint256 timestamp, uint256 deadline, bytes signature) external",
	"function resonanceRewardMap(address) view returns (tuple(uint256, uint256, uint256,bool))",
	"function levelDistributedMap(address) external view returns (uint256)",
	"function communityRewardDistributedMap(address) external view returns (uint256)",
	"function directReferrerRewardMap(address) view returns (tuple(uint256, uint256, uint256,bool))",
	"function withdrawCommunityReward(uint256 _withdrawUAmount, uint256 _tokenId, uint256 nonce, uint256 timestamp, uint256 deadline, bytes signature) external",
	"function withdrawLevelReward(uint256 _withdrawUAmount, uint256 _tokenId, uint256 nonce, uint256 timestamp, uint256 deadline, bytes signature) external",
	"function withdrawNftResonanceReward(uint256 _withdrawUAmount, uint256 _tokenId) external",
	"function withdrawDirectReferrerReward(uint256 _withdrawUAmount, uint256 _tokenId) external",
	"function resonanceDepositMap(address) view returns (uint256 depositU, uint256 version, bool exists, bool inResonance, uint256 tokenId)"
]
const INTERACTOR_INTERFACE = new Interface(INTERACTOR_ABI)

const LP_ABI= [
	"function computingPowerMap(address) external view returns (uint256)",
	"function withdrawnRewardMap(address) external view returns (uint256)",
	"function pendingReward(address account) external view returns (uint256)",
	"function totalComputingPower() external view returns (uint256)",
	"function launchAt() external view returns (uint256)",
	"function lastDistributionTime() external view returns (uint256)",
	"function DISTRIBUTION_PERIOD() external view returns (uint256)",
	"function calculatePendingReward(address account) external view returns (uint256)",
	"function claimRewardWithAuth(uint256 amount, uint256 nonce, uint256 timestamp, uint256 deadline, uint256 tokenId, uint256 burnAmount, bytes signature) external",
	"function getUsdtAmountOut(uint256 facAmount) public view returns (uint256 usdtAmount)",
	"function approveTrading() external"
]

const LP_INTERFACE = new Interface(LP_ABI)

const addresses = isMainnet === true
	? require('./addresses_mainnet.json')
	: require('./addresses.json');

const {Interactor, FAANFT, FireAntCoin, FAALiquidPool} = addresses;

module.exports = {
	USDT_ADDRESS: "0x55d398326f99059fF775485246999027B3197955",
	TEST_USDT_ADDRESS: "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd",
	ERC20_ABI,
	ERC20_INTERFACE,
	NFT_ABI,
	NFT_INTERFACE,
	INTERACTOR_ABI,
	INTERACTOR_INTERFACE,
	LP_ABI,
	LP_INTERFACE,
	ERC20,
	isProd: isProd,
	isMainnet: isMainnet,
	Tier: {
		Macau: 0,
		Dubai: 1,
		Monaco: 2,
		LasVegas: 3
	},
	Interactor,
	FAANFT,
	FireAntCoin,
	FAALiquidPool,
	signatureWalletList: [
		'0x01059D6ED90c426e143824ce604dA44fFF690285',
		'0x51851aB3b4294bd8b841bf33A6f8bA815BEC6109',
		'0xA7C6D9e498159EFD751Ddbb29e918e56f7215A2E',
		'0x2F08A48c80093b91FDCe2d8A9bB787E4B24F38ef',
		'0x12A1F2487D2D8f1E43f1db6c5260ed2445aA31A5',
		'0x43af4394faD8164f16F5407761BD244A30f0259F',
		'0x9ee43a5D79F53e02EC3eEfBB70b5b8E16bd326EC',
		'0x2edFFc4a810F6f87D111CD54244Bb14C012e8cB4',
		'0x449b88651d265f71036D1f3C3B2a467fD2F452d9',
		'0x5e9aB3bce256033B194DCC0E18eb590aA094B261'
	],
	debugWalletList: [
		'0xADb47b8eb5e72E90a03Cb37De03472BEe967E875'
	]
}